import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Icon from "@/components/Icon";

/**
 * header logo component
 * @param isMobile is or not mobile device
 */
const Logo = ({ isMobile = false }: { isMobile?: boolean }) => {
  const { t } = useTranslation();
  const router = useRouter();
  return (
    <Link className="mr-11 transition-opacity hover:opacity-80" href="/" aria-label={t("common.seo_title")} passHref data-qt="header_logo_click">
      <Icon name="logo_new" width={isMobile ? 102 : 160} height={isMobile ? 24 : 38} />
    </Link>
  );
};

export default Logo;
